import {Box, List, Typography} from '@mui/material';
import {TodoWithExpiration} from '../../hooks/todo/useTodos';
import TodoListItem from './TodoListItem';

interface TodoListProps {
  todos: TodoWithExpiration[];
  onEdit: (id: string) => void;
  uid?: string;
}

export default function TodoList({todos, onEdit, uid}: TodoListProps) {
  if (todos.length === 0) {
    return (
      <Box sx={{textAlign: 'center', py: 4}}>
        <Typography variant="body1" color="text.secondary">
          No todos found
        </Typography>
      </Box>
    );
  }

  return (
    <List>
      {todos.map((todo) => (
        <TodoListItem key={todo.id} todo={todo} onEdit={() => onEdit(todo.id)} uid={uid} />
      ))}
    </List>
  );
}
